import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsRecondo() {
  const descriptionList = [
    "Vous souhaitez retrouver un ordinateur comme neuf, avec des performances optimales et un système propre ? Ce service de reconditionnement complet permet de redonner une seconde vie à votre appareil.",
    "Il inclut une réinstallation complète du système d’exploitation, un nettoyage physique approfondi (avec dépoussiérage interne), et une optimisation des performances.",
    "Options supplémentaires : Transfert de données, installation de logiciels essentiels (supplément).",
  ];
  const deroulementList = [
    "1 Prise de rendez vous : nous convenons d'un rendez vous à mon atelier avec votre ordinateur.",
    "2 Sauvegarde des données (si demandé) : Possibilité de récupérer et restaurer vos fichiers après le reconditionnement (option payante).",
    "3  Nettoyage interne approfondi : Dépoussiérage des ventilateurs, des composants internes et application de nouvelle pâte thermique si nécessaire pour éviter la surchauffe.",
    "Réinstallation propre du système : Formatage complet et installation d’un nouveau système Windows, macOS ou Linux.",
    "4 :Mises à jour et optimisation : Installation des pilotes et des mises à jour essentielles pour garantir la stabilité et la rapidité du système.",
    "5 (Optionnel) Restauration des données et logiciels : Récupération des fichiers et réinstallation des logiciels courants (supplément).",
    "6 Tests et restitution : Dernières vérifications avant de vous contacter pour récupérer votre ordinateur comme neuf.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="RECONDITIONNEMENT"
        price="100€ TTC (au lieu de 120€)"
        atelier={true}
        domicile={true}
        time="3h - 6h"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="" />
    </div>
  );
}

export default TarifsRecondo;
